<template>
  <div
    class="absolute flex h-3 w-3 items-center justify-center rounded-full bg-ontick-blue-600"
    :class="positionClass"
  >
    <span class="h-3 w-3 animate-ping rounded-full bg-ontick-blue-600"></span>
    <span class="sr-only"> Você tem novas mensagens </span>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      validator: (val) => {
        // Top left = "tl"
        // Top right = "tr"
        // Bottom left = "bl"
        // Bottom right = "br"
        return ["tl", "tr", "bl", "br"].includes(val);
      },
    },
    // Distance from the border of the parent element. See available values here: https://v2.tailwindcss.com/docs/top-right-bottom-left
    distance: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    positionClass() {
      if (!this.position) {
        return null;
      } else {
        let array = [];
        if (this.position.includes("t")) {
          array.push(`top-${this.distance}`);
        }
        if (this.position.includes("b")) {
          array.push(`bottom-${this.distance}`);
        }
        if (this.position.includes("l")) {
          array.push(`left-${this.distance}`);
        }
        if (this.position.includes("r")) {
          array.push(`right-${this.distance}`);
        }
        return array.join(" ");
      }
    },
  },
};
</script>

<style></style>
